import apiClient from "../../../../../../services/apiClient";




async function actionGet(link, params, callback, err) {

    const url = `${link}?${params}`;

    const resp = await apiClient.get(url);

    if(resp) {
        callback(resp.data);
    } else {
        err(resp);
    }

}

export function getListBfn(data, callback, err) {

    const { district, periodStartYear } = data;

    const link = 'statistic_bfn';

    const params = `district=${district}&period=${periodStartYear}`;

    actionGet(link, params, callback, err);
}

export function getPeriods(isArchive, callback, err){

    const link = 'kindergartens/getKGGroupsYears';

    const params = isArchive ? `archive=true`: ``;


    const conv = (d)=>{
        const { cursor } = d;
        
        if(!cursor) return [];

        for(let index in cursor) {

            let distr = new Set();
            let SolPresent = false;
            
            for(let distIndex in cursor[index].dist) {
                if (!cursor[index].dist[distIndex].match(/Со/) ) {
                    distr.add(cursor[index].dist[distIndex]);
                } else {
                    SolPresent = true;
                }
            }

            if (SolPresent) {
                distr.add('Солом’янський');
            }

            cursor[index].dist = Array.from(distr).sort();  
        }

        const result = cursor.sort((a,b)=>{ if(a._id>b._id) return -1; if(b._id>a._id) return 1; return 0; });
        
        return callback(result);
    }

    actionGet(link, params, conv, err);

}

export function getListBenefits(data, callback, err){

    const { district, periodStartYear, area, age, period, benefit } = data;

    const link = 'statistic_benefits';

    const params = `district=${district}&period=${periodStartYear}&area=${area}&age=${age}&dateto=${period}&benefit=${benefit}`;

    actionGet(link, params, callback, err);

}

export function getListBfnHistory(data, callback, err){

    const { period, district } = data;
    
    const link = 'bfn_history';

    const params = `district=${district}&period=${period}`;

    actionGet(link, params, callback, err);

}

